import * as THREE from 'three';

export default class Raycaster {
    constructor() {
        this.raycaster = new THREE.Raycaster();
        this.rayOrigin = new THREE.Vector3(-3, 0, 0)
        this.rayDirection = new THREE.Vector3(10, 0, 0)
    }

    setFromCamera(screenPosition, camera) {
        this.raycaster.setFromCamera(screenPosition, camera);
    }

    intersectObjects(objects, recursive = false) {
        return this.raycaster.intersectObjects(objects, recursive);
    }
}